import { HeaderToolbar, Spinner } from "@xola/ui-kit";
import React, { useEffect, useState } from "react";
import { useIsFetching } from "react-query";
import { useDebounce } from "use-debounce";
import { useQueryParams } from "@/hooks/useQueryParams";
import { useSearchAutoFocus } from "@/hooks/useSearchAutoFocus";

interface EmailHistorySearchProps {
    onSearch: (value: string) => void;
}

export const EmailSearchBar = ({ onSearch }: EmailHistorySearchProps) => {
    const shouldAutoFocus = useSearchAutoFocus();
    const queryParams = useQueryParams();
    const [search, setSearch] = useState(queryParams.get("search") ?? "");
    const [debouncedSearch] = useDebounce(search.trim(), 500);
    const isFetching = useIsFetching(["emails"]);

    useEffect(() => {
        onSearch(debouncedSearch);
    }, [debouncedSearch]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <span className="ui-email-search-bar w-full flex-1">
            <HeaderToolbar.Search
                shouldHideMenu
                autoFocus={shouldAutoFocus}
                isLoading={!!isFetching}
                shouldStayOpen={false}
                placeholder="Search by name, email, or subject"
                onChange={setSearch}
            />
            {!!isFetching && <Spinner size="tiny" className="absolute top-2 right-4" />}
        </span>
    );
};
